import React, { useEffect } from 'react'
import { useLocation, Link } from 'react-router-dom';
import { Preview, ProductpageDetail } from '../../components';
import ReviewList from '../../components/Reviews/ReviewList';
import ReviewForm from '../../components/Reviews/ReviewForm';
import StarRating from '../../components/Reviews/StarRating';
import './Productpage.css'
import '../../components/Reviews/Reviews.css'

const Productpage = () => {
  const location = useLocation();
  const product = location.state?.product;

  useEffect(() => {
    window.scrollTo(0, 0)
  }) // eslint-disable-line

  if (!product) {
    return (
      <div style={{ textAlign: 'center', padding: '4rem' }}>
        <h3>Product not found.</h3>
        <Link to="/shop">Back to Shop</Link>
      </div>
    );
  }

  const { name, img1, img2, description, price, tags, _id, averageRating, totalReviews } = product;

  return (
    <div className='productPage'>
      <section className='sec1'>
        <Preview img1={img1} img2={img2} />
        <ProductpageDetail
          name={name}
          description={description}
          price={price}
          tags={tags}
          id={_id}
          primaryImg={img1}
        />
      </section>

      <section className='reviewsSection'>
        <h2>Customer Reviews</h2>
        {totalReviews > 0 && (
          <div className='reviewSummary'>
            <span className='avgScore'>{Number(averageRating).toFixed(1)}</span>
            <div>
              <StarRating value={averageRating} readOnly size="small" />
              <p className='totalCount'>{totalReviews} {totalReviews === 1 ? 'review' : 'reviews'}</p>
            </div>
          </div>
        )}
        <ReviewForm productId={_id} />
        <ReviewList productId={_id} />
      </section>
    </div>
  )
}

export default Productpage;
